__turbopack_context__.v({
  "className": "roboto_f859be34-module__Ti_kZq__className",
  "variable": "roboto_f859be34-module__Ti_kZq__variable",
});
